import { ControlValueConverter } from '@farris/devkit';

class ArrayConverter implements ControlValueConverter {

  constructor(private separator: string = ',') {
  }

  convertFrom(value: string): string[] {
    return value.split(this.separator);
  }

  convertTo(value: string[]): string {
    return value.join(this.separator);
  }
}

export { ArrayConverter };
